import { Fragment } from 'react'

import { useFavFilterGrowthBookEnabled } from 'features/FeatureFlag'
import {
  useGetCallTimelineQuery,
  useGetFollowersCallTimelineQuery,
} from 'store/api/yay/post'

import CallList from './components/CallList'

import './style.scss'

export enum CALL_TIMELINE_TYPE {
  follower = 'follower',
  all = 'all',
}

const CommonCallTimeline = ({ data }) => {
  if ((data?.posts?.length ?? 0) == 0) {
    return null
  }

  return (
    <Fragment>
      <div className="CallTimeline">
        <div className="CallTimeline__call_list">
          <CallList callList={data?.posts || []} />
        </div>
      </div>
    </Fragment>
  )
}

const PublicCallTimeline = () => {
  const sharedInterests = useFavFilterGrowthBookEnabled()

  const { data } = useGetCallTimelineQuery({
    number: 6,
    sharedInterests,
  })

  return <CommonCallTimeline data={data} />
}

const FollowingCallTimeline = () => {
  const { data } = useGetFollowersCallTimelineQuery({
    number: 6,
  })

  return <CommonCallTimeline data={data} />
}

const CallTimeline = ({
  timelineMode = CALL_TIMELINE_TYPE.follower,
}: {
  timelineMode: CALL_TIMELINE_TYPE
}) => {
  if (timelineMode === CALL_TIMELINE_TYPE.follower) {
    return <FollowingCallTimeline />
  } else {
    return <PublicCallTimeline />
  }
}

export default CallTimeline
